import React from 'react';
import Visa from 'assets/livenicons/visa.svg';
import Discover from 'assets/livenicons/discover.svg';
import Amex from 'assets/livenicons/amex.svg';
import PayPal from 'assets/livenicons/paypal.svg';
import ApplePay from 'assets/livenicons/applepay.svg';
import Maestro from 'assets/livenicons/maestro.svg';
import Mastercard from 'assets/livenicons/mastercard.svg';

import styles from './styles.module.scss';

export const PaymentsBrand = () => {
  return (
    <div className={styles.paymentsBrand}>
      <img src={PayPal} alt="" />
      <img src={ApplePay} alt="" />
      <img src={Visa} alt="" />
      <img src={Mastercard} alt="" />
      <img src={Maestro} alt="" />
      <img src={Discover} alt="" />
      <img src={Amex} alt="" />
    </div>
  );
};
